export default __webpack_public_path__ + "media/images/social/facebook-4b07c6a24653ba0a8e57663d4cbc4aa2.png";